export default __webpack_public_path__ + "a1d21b28113bb4a73c36781939a16c6c.mp4";